// extracted by mini-css-extract-plugin
export default {"productGallery":"VF-z","inQuickShop":"WF-z"};